export const MENU = [
  {
    key: 'init',
    title: '',
    items: [
      {
        title: 'Explorar',
        icon: 'home',
        name: 'Home',
        show: {
          isAuthenticated: true,
          isNotAuthenticated: true
        }
      },
      {
        title: 'Carrito de compras',
        icon: 'shopping_cart',
        name: 'Shopping-cart',
        show: {
          isAuthenticated: true,
          isNotAuthenticated: true
        }
      },
      {
        title: 'Consultar pedido',
        icon: 'shopping_bag',
        name: 'Search-order',
        show: {
          isAuthenticated: true,
          isNotAuthenticated: true
        }
      }
    ]
  },
  {
    key: 'profile',
    title: 'Cuenta',
    items: [
      {
        title: 'Cuenta',
        icon: 'account_box',
        name: 'Account',
        show: {
          isAuthenticated: true,
          isNotAuthenticated: false
        }
      },
      {
        title: 'Direcciones',
        icon: 'location_on',
        name: 'Addresses',
        show: {
          isAuthenticated: true,
          isNotAuthenticated: false
        }
      },
      {
        title: 'Historial de pedidos',
        icon: 'history',
        name: 'Orders',
        show: {
          isAuthenticated: true,
          isNotAuthenticated: false
        }
      },
      {
        title: 'Reclamos',
        icon: 'feedback',
        name: 'Claims',
        show: {
          isAuthenticated: true,
          isNotAuthenticated: false
        }
      },
      {
        title: 'Acceder',
        icon: 'account_box',
        name: 'Login',
        show: {
          isAuthenticated: false,
          isNotAuthenticated: true
        }
      },
      {
        title: 'Registrarse',
        icon: 'person_add',
        name: 'Register',
        show: {
          isAuthenticated: false,
          isNotAuthenticated: true
        }
      },
      {
        title: 'Recuperar cuenta',
        icon: 'mdi-account-lock',
        name: 'Recover-account',
        show: {
          isAuthenticated: false,
          isNotAuthenticated: true
        }
      }
    ]
  },
  {
    key: 'clublentes',
    title: 'Mas sobre Club Lentes',
    items: [
      {
        title: 'Nosotros',
        icon: 'store',
        name: 'About',
        show: {
          isAuthenticated: true,
          isNotAuthenticated: true
        }
      },
      {
        title: 'Politicas de privacidad',
        icon: 'security',
        name: 'Privacy-policies',
        show: {
          isAuthenticated: true,
          isNotAuthenticated: true
        }
      },
      {
        title: 'Terminos y condiciones',
        icon: 'mdi-handshake',
        name: 'Terms-and-conditions',
        show: {
          isAuthenticated: true,
          isNotAuthenticated: true
        }
      }
    ]
  }
]
